module.exports = __webpack_public_path__ + "img/40_2.d376c64f.jpg";